import React from "react";
import {
  Button,
  Flex,
  Text,
  Box,
  useToast,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  CheckboxGroup,
  Checkbox,
  Select,
  Textarea,
} from "@chakra-ui/core";
import { useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router";
import useAuth from "../../../context/AuthContext";
import { getUserProfile, updateProfile } from "../../../api/user.service";
import { getJobCertifications, getJobSectors } from "../../../api/jobs.service";
import { updateMentorProfile } from "../../../api/mentor.service";

const ProfileEditPage = () => {
  const { state } = useLocation();
  const [profile, setUserProfile] = React.useState(state);
  const history = useHistory();

  const userExpertise =
    profile.mentor.expertise && JSON.parse(profile.mentor.expertise);

  const { register, handleSubmit, errors, formState } = useForm();
  const [expertise, setExpertise] = React.useState([]);
  const toast = useToast();

  const {
    state: { user },
  } = useAuth();

  const onSubmit = async (values) => {
    try {
      const { data } = await updateMentorProfile({
        ...values,
        expertise: JSON.stringify(expertise),
      });
      console.log(data);

      history.push("/dashboard/me");
      toast({
        title: "Profile Update",
        description: "You have successfully updated your profile",
        position: "top",
        duration: 2500,
      });
    } catch (error) {
      toast({
        title: "Profile Update",
        desccription: "Profile update failed. Please try again",
        position: "top",
        duration: 2500,
        status: "error",
      });
    }
  };

  const getDate = (date) => {
    let currentDate = new Date(date);
    currentDate.setDate(currentDate.getDate());
    const parsedDate = currentDate.toISOString().substr(0, 10);

    return parsedDate;
  };

  React.useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const { data } = await getUserProfile();
        data && setUserProfile(data);
        console.log(data);
      } catch (error) {
        console.log("err", error);
      }
    };

    fetchUserProfile();
  }, []);

  return (
    <Box height='100%' w='100%' mt='10' pb='40'>
      <Text fontWeight='700' textAlign='center' fontSize='3xl' my={["2", "8"]}>
        Edit Profile
      </Text>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex direction={["column", "row"]}>
          <FormControl mb='6' mr={["0", "2"]} flex='1' isRequired>
            <FormLabel htmlFor='nationality' isInvalid={errors.nationality}>
              Nationality
            </FormLabel>
            <Input
              type='text'
              name='nationality'
              ref={register}
              defaultValue={profile.mentor.nationality}
            ></Input>
            <FormErrorMessage>
              {errors.nationality && errors.nationality.message}
            </FormErrorMessage>
          </FormControl>
          <FormControl mb='6' mr={["0", "2"]} flex='1' isRequired>
            <FormLabel htmlFor='title' isInvalid={errors.title}>
              Title
            </FormLabel>
            <Input
              type='text'
              placeholder='Title (Mr/Ms/Dr/Prof)'
              name='title'
              ref={register({ required: "Field is required" })}
              defaultValue={profile.mentor.title}
            ></Input>
            <FormErrorMessage>
              {errors.title && errors.title.message}
            </FormErrorMessage>
          </FormControl>
        </Flex>

        <FormControl
          mb='6'
          flex='1'
          isRequired
          isInvalid={errors.biography}
          mr={["0", "2"]}
        >
          <FormLabel htmlFor='biography'>Biography</FormLabel>
          <Box bg='green.50' padding='4' my='2'>
            <Text fontSize='14px'>
              Please attach a short biography which can be used in the process
              of matching you with a green business start-up. (Please note no
              more than 1-2 pages- not a detailed CV, but a short outline of
              your key experiences/ roles/ research etc)
            </Text>
          </Box>
          <Textarea
            placeholder=''
            name='biography'
            ref={register}
            defaultValue={profile.mentor.biography}
          ></Textarea>
          <FormErrorMessage>
            {errors.biography && errors.biography.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl mb='6' isInvalid={errors.residential_address} flex='1'>
          <FormLabel htmlFor='residential_address'>
            Residential Address
          </FormLabel>
          <Input
            type='text'
            placeholder='Residential Address'
            name='residential_address'
            ref={register}
            defaultValue={profile.mentor.residential_address}
          ></Input>
          <FormErrorMessage>
            {errors.residential_address && errors.residential_address.message}
          </FormErrorMessage>
        </FormControl>

        <FormControl mb='6' isInvalid={errors.expertise} flex='1'>
          <FormLabel htmlFor='expertise'>Expertise</FormLabel>
          <Box bg='green.50' padding='4' my='2'>
            <Text fontSize='14px'>
              Sectors of expertise (Please tick if applicable)
            </Text>
          </Box>
          {/* Agriculture/Agri-Business  
Water, Sanitation and Hygiene (WASH)
Renewable Energy and Energy Efficiency (REEE)
Circular economy businesses  
Other, Specify */}
          <CheckboxGroup
            colorScheme='green'
            spacing='6'
            name='expertise'
            onChange={(values) => setExpertise(values)}
            defaultValue={userExpertise}
          >
            <Checkbox value='Agriculture/Agri-Business'>
              Agriculture/Agri-Business
            </Checkbox>
            <Checkbox value='Water, Sanitation and Hygiene (WASH)'>
              Water, Sanitation and Hygiene (WASH)
            </Checkbox>
            <Checkbox value='Circular Economy Businesses'>
              Circular Economy Businesses
            </Checkbox>
            <Checkbox value='Other'>Other</Checkbox>
          </CheckboxGroup>

          {expertise.map((expertise) => {
            console.log({ expertise });
            return (
              expertise === "Other" && (
                <Input
                  mt='4'
                  type='text'
                  ref={register}
                  placeholder='Other, Specify'
                  name='expertise'
                ></Input>
              )
            );
          })}

          <FormErrorMessage>
            {errors.expertise && errors.expertise.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl mb='6' isInvalid={errors.motivation} flex='1'>
          <FormLabel htmlFor='motivation'>Motivation</FormLabel>
          <Box bg='green.50' padding='4' my='2'>
            <Text fontSize='14px'>
              What is your motivation for wanting to join the GrEEn project
              incubation and acceleration mentoring programme?
            </Text>
          </Box>
          <Textarea
            type='text'
            placeholder=''
            name='motivation'
            ref={register}
            defaultValue={profile.mentor.motivation}
          ></Textarea>
          <FormErrorMessage>
            {errors.motivation && errors.motivation.message}
          </FormErrorMessage>
        </FormControl>

        <FormControl mb='6' isInvalid={errors.skills} flex='1'>
          <FormLabel htmlFor='skills'>Skills</FormLabel>
          <Box bg='green.50' padding='4' my='2'>
            <Text fontSize='14px'>
              What key skills and experiences would you bring to the mentoring
              relationship?
            </Text>
          </Box>
          <Textarea
            type='text'
            placeholder=''
            name='skills'
            ref={register}
            defaultValue={profile.mentor.skills}
          ></Textarea>
          <FormErrorMessage>
            {errors.skills && errors.skills.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl mb='6' isInvalid={errors.experience} flex='1'>
          <FormLabel htmlFor='experience'>Experience</FormLabel>
          <Box bg='green.50' padding='4' my='2'>
            <Text fontSize='14px'>
              Please indicate any previous experiences in formal or informal
              mentoring programs
            </Text>
          </Box>
          <Textarea
            type='text'
            placeholder=''
            name='experience'
            ref={register}
            defaultValue={profile.mentor.experience}
          ></Textarea>
          <FormErrorMessage>
            {errors.experience && errors.experience.message}
          </FormErrorMessage>
        </FormControl>

        <FormControl mb='6' isInvalid={errors.benefit} flex='1'>
          <FormLabel htmlFor='benefit'>Benefit</FormLabel>
          <Box bg='green.50' padding='4' my='2'>
            <Text fontSize='14px'>
              What benefit might you gain from being a mentor?
            </Text>
          </Box>
          <Textarea
            type='text'
            placeholder=''
            name='benefit'
            ref={register}
            defaultValue={profile.mentor.benefit}
          ></Textarea>
          <FormErrorMessage>
            {errors.benefit && errors.benefit.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl mb='6' isInvalid={errors.research_interests} flex='1'>
          <FormLabel htmlFor='research_interests'>Research Interests</FormLabel>
          <Box bg='green.50' padding='4' my='2'>
            <Text fontSize='14px'>What are your research interests?</Text>
          </Box>
          <Textarea
            type='text'
            placeholder=''
            name='research_interests'
            ref={register}
            defaultValue={profile.mentor.research_interests}
          ></Textarea>
          <FormErrorMessage>
            {errors.research_interests && errors.research_interests.message}
          </FormErrorMessage>
        </FormControl>

        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          flex='1'
          w='100%'
        >
          <Button
            type='submit'
            variantColor='green'
            color='white'
            size='md'
            height='48px'
            width={["100%", "200px"]}
            _focus='none'
            my='5'
            isLoading={formState.isSubmitting}
          >
            Update
          </Button>
          <Button
            bg='red.400'
            color='white'
            height='48px'
            width={["100%", "100px"]}
            _focus='none'
            my='5'
            ml='4'
            _hover={{ bg: "red.600" }}
            onClick={() => history.goBack()}
          >
            Cancel
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default ProfileEditPage;
